import { z } from 'zod';

export const CompatibilityResultsSchema = z.object({
  hasMatchingBarredLocation: z.boolean(),
  isAvailable: z.boolean(),
  meetsMinPayRequirements: z.boolean(),
  jobProfileMeetsMinHoursRequirements: z.boolean(),
});

export type CompatibilityResults = z.infer<typeof CompatibilityResultsSchema>;

export const OpportunityIntakeCandidateResponseSchema = z.object({
  opportunityId: z.string().uuid(),
  submissionId: z.string().uuid(),
  positionId: z.string().uuid(),
  candidateId: z.string().uuid(),
  compatibilityResults: CompatibilityResultsSchema,
});

export type OpportunityIntakeCandidateResponse = z.infer<
  typeof OpportunityIntakeCandidateResponseSchema
>;
